import { executeRequest, Request } from '@jfs/network'
import { paymentLinksParser } from '../network/parsers/GetPaymentLinksParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = paymentLinksParser(data)
  return respData
}

const returnAppendLink = (querryParam: any) => {
  let SEARCH_QUERY = ''
  Object.keys(querryParam).map((item) => {
    if (SEARCH_QUERY.indexOf('?') < 0 && querryParam[item]) {
      SEARCH_QUERY = `${SEARCH_QUERY}?${item}=${querryParam[item]}`
    } else if (querryParam[item]) {
      SEARCH_QUERY = `${SEARCH_QUERY}&${item}=${querryParam[item]}`
    }
  })
  return SEARCH_QUERY
}

const getPaymentLinks = async (requestBody: any, tokens: any, userAccessToken: string, querryParam: any) => {
  const appendLinkData = await returnAppendLink(querryParam)
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.getAllPaymentLinks}${appendLinkData ?? ''}`,
    method: 'POST',
    body: requestBody,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data?.data)
  })
}

export { getPaymentLinks }
